import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { DropdownEntry } from "~/common/types";
import {
  formOptionsQueryOptions,
  type CountryFormOption,
  type FormOption,
} from "~/domains/referenceData/api/formOptions";

const EMPTY_FORM_OPTIONS: FormOption[] = [];
const EMPTY_COUNTRY_OPTIONS: CountryFormOption[] = [];

export function useFormOptions() {
  return useQuery(formOptionsQueryOptions());
}

export function useTitleOptions(): DropdownEntry<string>[] {
  const { t } = useTranslation();
  const { data } = useFormOptions();
  const options = data?.titleOptions ?? EMPTY_FORM_OPTIONS;
  return useMemo(() => options.map((option) => ({ value: option.code, label: t(option.name) })), [options, t]);
}

export function useSalutationOptions(): DropdownEntry<string>[] {
  const { t } = useTranslation();
  const { data } = useFormOptions();
  const options = data?.salutationOptions ?? EMPTY_FORM_OPTIONS;
  return useMemo(() => options.map((option) => ({ value: option.code, label: t(option.name) })), [options, t]);
}

export function useCountryOptions(): DropdownEntry<string>[] {
  const { t } = useTranslation();
  const { data } = useFormOptions();
  const options = data?.countryOptions ?? EMPTY_COUNTRY_OPTIONS;
  return useMemo(
    () =>
      options
        .map((option) => ({
          value: option.isoCode,
          label: t(option.name),
          stringLabel: t(option.name),
        }))
        .sort((left, right) => left.stringLabel.localeCompare(right.stringLabel)),
    [options, t],
  );
}
